// Shared constants for the Country Adventure modal.

export const CARD_META = {
  animal: { icon: '\uD83D\uDC3E', title: 'Animals', color: '#16a34a', bg: '#dcfce7' },
  food: { icon: '\uD83C\uDF7D\uFE0F', title: 'Local Food', color: '#ea580c', bg: '#ffedd5' },
  landmark: { icon: '\uD83C\uDFDB\uFE0F', title: 'Famous Place', color: '#2563eb', bg: '#dbeafe' },
  fact: { icon: '\u2728', title: 'Fun Fact', color: '#ca8a04', bg: '#fef3c7' },
  culture: { icon: '\uD83C\uDF89', title: 'Culture', color: '#7c3aed', bg: '#ede9fe' },
};

export const CARD_COPY = {
  animal: (content) => content.animals?.slice(0, 3).join(', '),
  food: (content) => content.dish,
  landmark: (content) => content.landmark,
  fact: (content) => content.funFact,
  culture: (content) => content.culture,
};

export const COUNTRY_THEMES = [
  ['#f97316', '#14b8a6', '#1d4ed8'],
  ['#ef4444', '#facc15', '#2563eb'],
  ['#16a34a', '#f59e0b', '#0f766e'],
  ['#db2777', '#f97316', '#0891b2'],
  ['#7c3aed', '#22c55e', '#f59e0b'],
];
